import React, { useState } from 'react'
import { Wrapper } from './style'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { PlanTypes } from 'src/redux/types/planTypes'
import { ModalButton } from 'src/components/Global/Button/Button'
import { ModalTitleText } from 'src/components/Global/Text/TitleText'

import 'react-toastify/dist/ReactToastify.css'
const PlanType = () => {
  const [automatedChecked, setautomatedChecked] = useState(true)
  const [manualChecked, setmanualChecked] = useState(false)
  const [automated, setAutomated] = useState(true)
  const [planData, setPlanData] = useState({
    saving_type: '',
  })

  let location = useLocation()
  const dispatch = useDispatch()
  const { saving_type } = planData

  const handleautomatedOnChange = () => {
    setautomatedChecked(!automatedChecked)
    setmanualChecked(!manualChecked)
    planData.saving_type = 'automated'
    automatedChecked
      ? dispatch(action(PlanTypes._UPDATE_PLAN_FORM, planData))
      : dispatch(action(PlanTypes._UPDATE_PLAN_FORM, planData))
  }

  const handleManualOnChange = () => {
    setmanualChecked(!manualChecked)
    setautomatedChecked(!automatedChecked)
    setAutomated(!automated)
    planData.saving_type = 'manual'
    manualChecked
      ? dispatch(action(PlanTypes._UPDATE_PLAN_FORM, planData))
      : dispatch(action(PlanTypes._UPDATE_PLAN_FORM, planData))
  }
  return (
    <Wrapper>
      <div className="pageNumber"></div>
      <form className="content">
        <div className="top-form">
          <ModalTitleText>Saving Type</ModalTitleText>
          <p className="desc">How do you want your savings to be?</p>
          <div className="frequency">
            <label className="container">
              Automated
              <input
                type="radio"
                checked={automatedChecked}
                name="saving_type"
                value="saving_type"
                onChange={handleautomatedOnChange}
              />
              <span className="checkmark"></span>
            </label>
            {automatedChecked && (
              <Link
                to={`/general-frequency`}
                state={{ backgroundLocation: location }}
              >
                <div>
                  <p className="desc reverse">Monthly(tap to change)</p>
                </div>
              </Link>
            )}
          </div>
          <label className="container">
            Manually
            <input
              type="radio"
              checked={manualChecked}
              name="saving_type"
              value={saving_type}
              onChange={handleManualOnChange}
            />
            <span className="checkmark"></span>
          </label>
        </div>
        <div>
          <Link
            to={`/plan-created-details`}
            state={{ backgroundLocation: location }}
          >
            <ModalButton className="button">Continue</ModalButton>
          </Link>
        </div>
      </form>
    </Wrapper>
  )
}

export { PlanType }
